import { defineStore } from 'pinia'
import { store } from '@/stores'
import designSetting from '@/settings/designSetting'
const { darkMode, appTheme, appThemeList } = designSetting

export const useDesignStore = defineStore('base', {
  id: 'app-base',
  state: () => ({
    darkMode,
    appTheme,
    appThemeList
  }),
  getters: {
    getDarkMode() {
      return this.darkMode // 'light' | 'dark'
    },
    getAppTheme() {
      return this.appTheme
    },
    getAppThemeList() {
      return this.appThemeList
    }
  },
  actions: {
    setDarkMode(mode) {
      this.darkMode = mode
    }
  },
  // 持久化
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'DESIGN-SETTING',
        storage: localStorage
      }
    ]
  }
})

export function useDesignStoreWithOut() {
  return useDesignStore(store)
}
